import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
const Center = ({ children }) => {
    return (_jsx(Box, Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" // 100% of the viewport height
        , width: "100vw" // 100% of the viewport width
     }, { children: children })));
};
export default Center;
